<script>
  import { createEventDispatcher } from 'svelte';
  import { getApiUrl } from '../api';

  export let value = ''; // The store name (two-way bound)
  export let placeholder = '';
  export let required = false;

  let suggestions = [];
  let showSuggestions = false;
  let inputElement;

  const dispatch = createEventDispatcher();

  async function handleInput() {
    // 1. Update parent
    dispatch('input', value);

    // 2. Fetch suggestions if length > 1
    if (value.length < 2) {
      suggestions = [];
      showSuggestions = false;
      return;
    }

    try {
      const response = await fetch(getApiUrl(`/stores/search?q=${encodeURIComponent(value)}`));
      if (response.ok) {
        suggestions = await response.json();
        showSuggestions = suggestions.length > 0;
      }
    } catch (e) {
      console.error("Autosuggest error", e);
    }
  }

  function selectSuggestion(suggestion) {
    value = suggestion;
    showSuggestions = false;
    dispatch('input', value); // Notify parent of final selection
  }

  // Close dropdown when clicking outside
  function handleWindowClick(e) {
    if (inputElement && !inputElement.contains(e.target)) {
      showSuggestions = false;
    }
  }
</script>

<svelte:window on:click={handleWindowClick} />

<div class="autocomplete-wrapper" bind:this={inputElement}>
  <input 
    type="text" 
    bind:value={value} 
    {placeholder} 
    {required} 
    on:input={handleInput}
    on:focus={() => value.length >= 2 && handleInput()}
    autocomplete="off"
  />
  
  {#if showSuggestions}
    <ul class="suggestions-list">
      {#each suggestions as suggestion}
        <li on:click={() => selectSuggestion(suggestion)}>
          {suggestion}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .autocomplete-wrapper {
    position: relative;
    width: 100%;
  }
  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
    box-sizing: border-box;
  }
  .suggestions-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-top: none;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 10;
    max-height: 200px;
    overflow-y: auto;
  }
  li {
    padding: 0.75rem;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }
  li:last-child {
    border-bottom: none;
  }
  li:hover {
    background-color: #f8f9fa;
    color: #007bff;
  }
</style>